'use client';
import React, { useState, useEffect } from 'react';
import Link from 'next/link';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollToForm = () => {
    document.getElementById('consultation-form')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-[#0a0a1a]/95 backdrop-blur-md border-b border-indigo-500/20 py-3'
          : 'bg-transparent py-5'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        {/* Logo */}
        <Link href="/" className="flex items-center gap-2.5">
          <div
            className="flex items-center justify-center rounded-xl shadow-lg flex-shrink-0"
            style={{
              width: 36,
              height: 36,
              background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)',
              border: '1px solid rgba(99,102,241,0.4)',
            }}
          >
            <svg width={20} height={20} viewBox="0 0 18 18" fill="none">
              <path d="M3 3h5v2H5v8h3v2H3V3z" fill="white" fillOpacity="0.9" />
              <path d="M10 3h5v2h-3v3h3v2h-3v3h3v2h-5V3z" fill="#818cf8" />
              <circle cx="14" cy="4" r="1.5" fill="#6366f1" />
            </svg>
          </div>
          <div className="flex flex-col leading-none">
            <span className="font-bold text-white tracking-tight text-[16px]" style={{ letterSpacing: '-0.02em' }}>
              LEXIGEN <span style={{ color: '#818cf8' }}>AI</span>
            </span>
            <span className="text-[9px] font-medium tracking-widest uppercase" style={{ color: 'rgba(255,255,255,0.4)' }}>Legal Platform</span>
          </div>
        </Link>

        {/* Nav links */}
        <nav className="hidden md:flex items-center gap-8">
          {['Features', 'Pricing', 'About']?.map((item) => (
            <a
              key={item}
              href={`#${item?.toLowerCase()}`}
              className="text-[11px] font-medium tracking-widest uppercase transition-colors hover:text-white/90"
              style={{ color: 'rgba(255,255,255,0.5)' }}
            >
              {item}
            </a>
          ))}
        </nav>

        {/* CTAs */}
        <div className="flex items-center gap-3">
          <Link
            href="/login"
            className="text-[12px] font-medium tracking-wide transition-colors hidden sm:block hover:text-white/90"
            style={{ color: 'rgba(255,255,255,0.6)' }}
          >
            Sign in
          </Link>
          <Link
            href="/onboarding"
            className="text-white text-[12px] font-semibold px-5 py-2.5 rounded-xl transition-all shadow-lg hover:opacity-90"
            style={{ background: 'linear-gradient(135deg, #4f46e5, #6366f1)', boxShadow: '0 4px 15px rgba(99,102,241,0.3)' }}
          >
            Start Your Business
          </Link>
        </div>
      </div>
    </header>
  );
}